module.exports = __webpack_public_path__ + "static/img/ztjz.a424f72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/ztjz.png
// module id = OGZI
// module chunks = 1